import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InputValidationService {
  /**
   * Validates numeric input with decimal point
   * @param event Keyboard event to validate
   * @returns boolean indicating if the input is valid
   */
  onNumericKeyPress(event: KeyboardEvent): boolean {
    // Allow only numbers and decimal point
    const pattern = /^[0-9.]$/;
    const inputChar = String.fromCharCode(event.charCode);

    // Check if the input matches our pattern
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }

    // Get the current value of the input
    const element = event.target as HTMLInputElement;
    const currentValue = element.value;

    // Prevent multiple decimal points
    if (inputChar === '.' && currentValue.includes('.')) {
      event.preventDefault();
      return false;
    }

    return true;
  }
}
